import { Controller } from "@hotwired/stimulus"

/**
 * IoT Pairing Form Controller (CONEK-4142, Plan 32 §9)
 *
 * Handles the transient "submitting" state of the pairing form. On submit
 * we swap the button label for a spinner so the user gets immediate
 * feedback before the Turbo Stream response replaces the whole panel.
 *
 * Per CLAUDE.md "no disabled submit buttons" rule, the submit button is
 * kept clickable when there's nothing to process — but we DO disable it
 * during an active submission (loading state) to prevent accidental
 * double-submission. Once Turbo replaces `pairing_panel` with the
 * `:in_progress` state, this whole controller is detached and the
 * transient state ceases to exist with it.
 *
 * @example
 *   <form data-controller="iot--pairing-form"
 *         data-action="submit->iot--pairing-form#submit">
 *     <button data-iot--pairing-form-target="submit">
 *       <span data-iot--pairing-form-target="submitLabel">Pair</span>
 *       <span data-iot--pairing-form-target="submitSpinner" class="hidden">...</span>
 *     </button>
 *   </form>
 */
export default class extends Controller {
  static targets = ["submit", "submitLabel", "submitSpinner"]

  submit() {
    this.enterLoadingState()
  }

  enterLoadingState() {
    if (this.hasSubmitLabelTarget)
      this.submitLabelTarget.classList.add("hidden")
    if (this.hasSubmitSpinnerTarget)
      this.submitSpinnerTarget.classList.remove("hidden")
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
      this.submitTarget.setAttribute("aria-busy", "true")
    }
  }
}
